import React from "react";

function TReachAbout() {
  return (
    <div className="min-h-screen bg-black text-white p-2 flex flex-col items-center">
      <h1 className="text-xl font-bold text-blue-400 mt-2">TransformReach 🔄📡</h1>
      <p className="text-sm text-gray-400 mt-1">ATL • BTL • TTL — Transforming Reach for the Next Generation</p>

      <div className="mt-2 text-base leading-relaxed text-gray-300 space-y-4">
        <p>
          <strong className="text-blue-300">TransformReach (TReach)</strong> is a next‑generation
          boutique marketing and transformation platform built on the Think5Whys
          TransformX ecosystem. It empowers youth entrepreneurs, MSMEs, creators,
          consultants, and small agencies to launch and operate their own
          <strong> ATL, BTL, and TTL campaigns </strong> without needing complex tools,
          expertise, or large budgets.
        </p>

        <p>
          Designed with a mobile‑first mindset, TReach offers an ultra‑simple,
          powerful, and AI‑assisted environment where anyone can plan, launch,
          manage, and analyze marketing campaigns using curated workflows,
          automation, smart recommendations, and real‑time analytics. From mass
          outreach campaigns (ATL 📺), direct engagement activities (BTL 🎯), to
          integrated omni‑channel strategies (TTL 🔄), TransformReach makes
          professional‑grade marketing accessible to everyone.
        </p>

        <p>
          TReach functions as a <strong> boutique advisory + operational engine</strong>—a
          platform where young marketing professionals can register, learn,
          collaborate, and even run their own micro‑agency business using
          pre‑built templates, campaign tools, operations management, customer
          feedback capture, logs, exports, and visual analytics.
        </p>

        <p>
          Whether you're scaling a brand, launching a product, activating a
          community, or managing multi‑channel engagements, TransformReach offers a
          clean, modern, and intelligent workspace to make your marketing journey
          seamless and impactful.
        </p>
      </div>

      {/* Footer Section */}
      {/* <div className="mt-10 mb-8">
        <button className="px-6 py-3 rounded-xl bg-blue-500 text-black font-bold shadow-xl hover:bg-blue-400">
          Start Your Journey 🚀
        </button>
      </div> */}
    </div>
  );
}

export default TReachAbout;
